import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseSearchBarFacade } from '@app/modules/shared/base-search-bar/base-search-bar-facade';
import { ImageCdnPipe } from '@app/pipes/image-cdn.pipe';
import { isNullOrUndefined } from '@app/util/util';
import { HotelFilterApplier, HotelFilterTypes } from '@shared/hotel-itinerary/hotel-filters';
import { packHours } from '@shared/magic-filter-bar/byhours-filter-hour/constants/byhours.constant';
import {
  TypographyFontSize, TypographyColor, TypographyFontFamily
} from '@design-system/components/atoms/typography/entities/typography.types';
import {
  FloatingFilterSize, FloatingFilterType
} from '@design-system/components/organisms/floating-filter/entities/floating-filter.types';

@Component({
  selector: 'app-byhours-filter-hour',
  templateUrl: './byhours-filter-hour.component.html',
  styleUrls: ['./byhours-filter-hour.component.sass'],
  standalone: false
})
export class ByhoursFilterHourComponent {

  public readonly BASE_PATH: string = 'web/travel/byhours';
  public readonly hours = packHours
  
  @Input() hourType: string[];
  @Input() isResults = false;
  @Output() hourTypeSelected: EventEmitter<HotelFilterApplier> = new EventEmitter<HotelFilterApplier>();

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  public readonly floatingFilterType = FloatingFilterType.Image;
  public readonly floatingFilterSize = FloatingFilterSize.LG;
  
  constructor(
    readonly imageCdnPipe: ImageCdnPipe,
    readonly baseSearchBarFacade: BaseSearchBarFacade
  ) { }

  public trackById(index: number): number {
    return index;
  }

  public hoursImageUrl(hour: string): string {
    if (hour) {
      const imageName = `timer-${ hour }${this.isActiveHour(hour) ? '-active' : ''  }.svg`;
      return this.imageCdnPipe.baseImage(imageName, this.BASE_PATH);
    } else {
      return null;
    }
  }

  public isActiveHour(hour: string): boolean {
    if (!isNullOrUndefined(this?.hourType) && Array.isArray(this?.hourType)) {
      return this.hourType?.includes(hour);
    }
  }  

  public hourSelected(event: string): void {
    this.hourType = [event];
    this.baseSearchBarFacade.selectHourType([event]);
    this.hourTypeSelected.emit({
      type: HotelFilterTypes.PackHours,
      removable: false,
      value: [event]
    });
  }

}
